import { translatableZodSchema } from "@@/shared/translations/translation";
import { userIdZodSchema } from "@@/shared/users/user-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { signatureFactory } from "../signature-factory";
import type {
    _OrderEventBaseFactoryParams} from "./_order-base.event";
import {
    _orderEventBaseFactory,
    _orderEventBaseZodObject,
} from "./_order-base.event";

const orderEventRejectedZodSchema = _orderEventBaseZodObject.merge(
    z.object({
        type: z.literal("REJECTED"),
        reason: translatableZodSchema,
        rejectedBy: userIdZodSchema,
    }),
);
type OrderRejectedEvent = z.infer<typeof orderEventRejectedZodSchema>;

type FactoryParams = _OrderEventBaseFactoryParams &
    Except<
        OrderRejectedEvent,
        "type" | "_id" | "_type" | "_createdAt" | "signature"
    >;

type Params = Except<FactoryParams, "signature">;

const orderEventRejectedFactory = (params: Params): OrderRejectedEvent => ({
    ..._orderEventBaseFactory({
        orderId: params.orderId,
        orderGroupId: params.orderGroupId,
        _version: params._version,
        providerId: params.providerId,
        providerSlug: params.providerSlug,
        signature: signatureFactory(params.orderId, "REJECTED"),
    }),

    type: "REJECTED",
    reason: params.reason,
    rejectedBy: params.rejectedBy,
});

export { orderEventRejectedFactory, orderEventRejectedZodSchema };
export type { OrderRejectedEvent };
